import React from 'react'
import moment from 'moment'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import FormPurchaseOrder from 'src/components/form/general-input-form/FormPurchaseOrder'
import FormProjectTerms from 'src/components/form/general-input-form/FormProjectTerms'

// helpers
import { convertMoney } from '../../../helpers/format-number'
import { capitalizeFirstLetter } from '../../../helpers/text-format'

const AppDetails = ({
  projectDetails,
  setOpenFilePreview
}) => {
  let employeeAssigned = projectDetails.employee_assignments?.length > 0 ? projectDetails.employee_assignments?.map((item) => item?.label) : []
  let projectTerms = []
  if (projectDetails.terms?.length > 0) {
    projectTerms = projectDetails.terms?.map((item) => {
      return {
        term_name: item?.term_name || '',
        term_percentage: item?.percentage || '',
        term_value: item?.value || '',
        term_tax_value: item?.tax_value || ''
      }
    })
  }

  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Project name"
          subtitle={projectDetails?.name ? projectDetails?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Project value"
          subtitle={projectDetails?.value ? `IDR ${convertMoney(projectDetails?.value)}` : '-'}
        />
        <AppTextColumnDetails
          colSize="6"
          title="Project Tax and other fees"
          subtitle={projectDetails?.tax_value ? `IDR ${convertMoney(projectDetails?.tax_value)}` : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Project Start Date"
          subtitle={projectDetails?.start_date ? moment(projectDetails?.start_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Project End Date"
          subtitle={projectDetails?.end_date ? moment(projectDetails?.end_date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          colSize="6"
          title="Project Description"
          subtitle={projectDetails?.description ? projectDetails?.description : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Client Name"
          subtitle={projectDetails?.client?.name ? projectDetails?.client?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Team In Charge In This Project"
          subtitle={employeeAssigned?.length > 0 ? employeeAssigned.join(', ') : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Payment Tempo"
          subtitle={projectDetails?.payment_tempo ? projectDetails?.payment_tempo == 'Others' ? projectDetails?.other_payment_tempo : projectDetails?.payment_tempo : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Progress Status"
          subtitle={projectDetails?.status ? capitalizeFirstLetter(projectDetails?.status) : '-'}
        />
      </CRow>
      {
        projectDetails?.purchase_orders?.length > 0 && (
          <CRow className='mb-4'>
            <FormPurchaseOrder 
              inputLabel={'Purchase Order'}
              purchase_orders={projectDetails.purchase_orders}
              isDetail={true}
              setOpenFilePreview={setOpenFilePreview}
            />
          </CRow>
        )
      }
      {
        projectDetails?.terms?.length > 0 && (
          <CRow className='mb-4'>
            <FormProjectTerms 
              inputLabel={'Payment Terms'}
              project_terms={projectTerms}
              isDetail={true}
            />
          </CRow>
        )
      }
    </>
  )
}

export default AppDetails
